import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

// Components
import SidebarMapDisableContainer from '../SidebarMapDisableContainer/SidebarMapDisableContainer';

// Store
import { $adminSelected, $fieldSelected, setFieldSelected } from '../../../store/slices/sidebarMapFiltersSlice';

// Configs
import { RADIO_BUTTON_STYLE } from '../../../configs/muiStyling.config';
import { ADMIN__Admin1, SIDEBAR_MAP_FILTER_FIELDS } from '../../../configs/map.configs';
import { SidebarMapFilterFieldsType } from '../../../configs/types';

// Styles
import './SidebarMapFiltersField.scss';

function SidebarMapFiltersField() {
  const dispatch = useDispatch();
  const adminSelected = useSelector($adminSelected);
  const fieldSelected = useSelector($fieldSelected);

  const admin1Selected = adminSelected === ADMIN__Admin1;

  useEffect(() => {
    if (admin1Selected) {
      dispatch(setFieldSelected(SIDEBAR_MAP_FILTER_FIELDS[0].value));
    }
  }, [adminSelected]);

  const handleSidebarMapTypeFilters = (event: any) => {
    const fieldSelected = event.target.value;
    if (import.meta.env.MODE === 'development') {
      console.log('value:', fieldSelected);
    }

    dispatch(setFieldSelected(fieldSelected));
  };

  return (
    <div className={'SidebarMapFiltersField sidebar-map-options'}>
      {admin1Selected && <SidebarMapDisableContainer />}

      <FormControl>
        <RadioGroup row value={fieldSelected} name='sidebar-map-type-filters' onChange={handleSidebarMapTypeFilters}>
          {SIDEBAR_MAP_FILTER_FIELDS.map((field: SidebarMapFilterFieldsType, index: number) => {
            const { label, value, tooltip } = field;

            return (
              <FormControlLabel
                className={'SidebarMapFiltersField__option'}
                key={`field_${index}`}
                value={value}
                label={label}
                title={tooltip}
                disabled={admin1Selected}
                control={<Radio sx={RADIO_BUTTON_STYLE} />}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
}

export default SidebarMapFiltersField;
